import css from 'styled-jsx/css';

const styles = css.global`#santander-servicos {
  position: relative;
  z-index: 50;
  padding: 32px 0;
  overflow: hidden;
}

.text-headline {
  color: #222222;
  font-family: 'SantanderHeadline';
  font-size: 24px;
  letter-spacing: 0;
  line-height: 36px;
  margin: 0 0 16px;
  font-weight: 400;
}

.text-headline b {
  font-weight: 800 !important;
}

@media (min-width: 992px) {
  #santander-servicos {
    padding: 64px 0;
  }

  .text-headline {
    color: #222222;
    font-family: 'Open Sans';
    font-size: 32px;
    letter-spacing: 0;
    line-height: 43px;
  }

  #santander-servicos .service-card {
    margin-right: 37px;
  }

  /* 
  #santander-servicos .custom-carousel .fill-height {
    overflow-x: clip;
  }
  #santander-servicos .custom-carousel .embla__container {
    overflow: visible;
  } */

}

#santander-servicos .home-pagination {
  margin-top: 24px;
}

#santander-servicos .home-pagination .embla__prev {
  width: 24px;
  height: 24px;
  background-image: url(assets/home24/shared/ic_arrow_left_red.svg);
  background-size: 24px 24px;
}

#santander-servicos .home-pagination .embla__next {
  width: 24px;
  height: 24px;
  background-image: url(assets/home24/shared/ic_arrow_right_red.svg);
  background-size: 24px 24px;
}


#santander-servicos div.slide {
  flex: 0 0 150px;
}

.headline {
  max-width: 210px;
}

.service-card {
  width: 148px;
  height: 122px;
  margin: 7px 0;
  /* border: 1px solid #cccccc; */
  border-radius: 4px;
  background: #FBFBFB;
  box-shadow: 0px 4px 8px 0px rgba(34, 34, 34, 0.12);
  overflow: visible;

  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  text-align: center;
  box-sizing: border-box;

  cursor: pointer;

  margin-right: 16px;

  position: relative;

  transition: all 0.2s;
  padding: 16px 8px;
}

.service-card img {
  width: 40px;
  height: 30px;
}

.service-card .card-dois-icones {
  display: flex;
  align-items: center;
}

.service-card h3 {
  color: #444;
  text-align: center;
  font-family: "SantanderMicroText";
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 22px;
  margin: 0;
}

.service-card:hover {
  box-shadow: 0px 2px 16px -2px rgb(34 34 34 / 40%);
}

#santander-servicos amp-carousel .fix-position {
  position: relative;
  top: -3px;
}

.service-card.no-margin {
  margin-right: 0;
}

.service-card .tag-destaque {
  background-color: #609E55;
  border-radius: 4px;
  color: #ffffff;
  border: none;
  font-family: 'SantanderHeadline';
  font-size: 14px;
  padding: 8px 15px;
  position: absolute;
  top: -15px;
  z-index: 42;
}

.service-card .flag-destaque {
  position: absolute;
  top: -10px;
  z-index: 42;
}

.service-card .flag-destaque img {
  width: 145px;
}

#santander-servicos amp-carousel .amp-carousel-button {
  background-color: transparent;
  width: 24px;
  height: 40px;
  opacity: 1;
  background-size: 24px 40px;
  outline: none;
  border: none;
  cursor: pointer;
}

#santander-servicos amp-carousel .amp-carousel-button-next {
  background-image: url('static/amp/shared/assets/ic_arrow2_r.svg');
}

#santander-servicos amp-carousel .amp-carousel-button-prev {
  background-image: url('static/amp/shared/assets/ic_arrow2_l.svg');
}

@media (min-width: 768px) {
  .headline {
    max-width: 1000px;
  }

  /* .service-card {
    margin-right: 40px;
  } */

}

@media (min-width: 992px) {
  .text-headline b {
    font-weight: 600 !important;
  }
}

@media (min-width: 1250px) {

  /* #santander-servicos {
    height: 270px;
  } */
  #santander-servicos .service-card {
    margin-right: 13px;
  }

  #santander-servicos .home-pagination {
    display: none;
  }
}`;

export default styles;